<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3u4Jj4/tc-custom/9781426847172.jpg?1700277890567" alt="This image is the cover for the book Double Deception"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Double Deception
      </h1>
      <p class="bookDescription body article font2">
        <p>Her faith had always been strong enough to see herthrough tragedy—until Kate Wheeler's world turneddeadly. Her husband had been murdered, and thediscovery of his double life sent her on the runinto the protective custody of Sheriff Brody McClain.Brody vowed to help Kate uncover the truth about herhusband's death. As Kate and Brody tried to outwit herenemies on a cross-country chase, the couple foundthemselves drawn to each other by more than merecircumstance. But the unmasking of thecriminal mastermind might just be the thingthat destroys Kate's trust—and faith—forever.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Terri Reed
      </h2>
      
      <p class="authorDescription body article">Award winning, multipublished author Terri Reed writes heart-warming romance and heart-pounding suspense. Her books have appeared on Publisher&#39;s Weekly top ten, Nielsen&#39;s Bookscan top fifty, Amazon Bestseller and featured in USA Today.&#160; You can visit her online at www.terrireed.com or email her at terrireed@sterling.net&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?67fd9389